<template>
  <div v-frag>
    <v-snackbar
      v-model="snackbar.view"
      :color="snackbar.config.color"
      right
      top
      :value="snackbar.value"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbarClose()">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
export default {
  name: "SnackbarAlert",
  mounted() {},
  data: () => ({
    //   snackbar:true
  }),
  computed: {
    snackbar() {
      return this.$store.getters.snackbar;
    }
  },
  watch: {
    snackbar: {
      handler() {
        if (this.snackbar.view) {
          setTimeout(() => {
            this.snackbarClose();
          }, 5000);
        }
      },
      deep: true
    }
  },
  methods: {
    snackbarClose() {
      this.$store.dispatch("snackbar", {
        view: false,
        text: "",
        config: { color: "" }
      });
    }
  }
};
</script>
